import { tr } from 'mmfintech-commons'
const NewsBullet = ({ index, active, handleTransition }) => (
  <button
    type='button'
    aria-label={tr('FRONTEND.NEWS.GO_TO_ITEM', 'Go to news {{index}}', { index: index + 1 })}
    className={`bullet ${active ? 'active' : ''}`}
    onClick={() => handleTransition(index)}
  />
)

export default NewsBullet
